import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_TORNEOS,
  ALL_TORNEOS,
  LOADING_ALL_TORNEOS,
} from './TorneosReducer';
import {
  deleteTorneosService,
  allTorneosService,
  oneTorneosService,
  saveTorneosService,
} from './TorneosService';

export const allTorneosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_TORNEOS, payload: true });
    const res = await allTorneosService(params);
    dispatch({ type: ALL_TORNEOS, payload: res.data });
    dispatch({ type: LOADING_ALL_TORNEOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_TORNEOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveTorneosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveTorneosService(id, data);
    notify(res.data.message);
    await allTorneosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoTorneosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_TORNEOS, payload: data });
};

export const oneTorneosAction = async (dispatch, id) => {
  try {
    const res = await oneTorneosService(id);
    await setActivoTorneosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteTorneosAction = async ({ dispatch, notify }, id, params) => {
  try {
    const res = await deleteTorneosService(id);
    notify(res.data.message);
    await setActivoTorneosAction(dispatch, null);
    await allTorneosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
